/**
 * Skeleton Chart Component
 * Loading placeholder for AlertTrendsChart dashboard section
 */

import { Card, Box, SkeletonBodyText, BlockStack } from '@shopify/polaris';

interface SkeletonChartProps {
  /**
   * Height of the chart area
   * @default '300px'
   */
  height?: string;

  /**
   * Whether to show title skeleton
   * @default true
   */
  showTitle?: boolean;
}

/**
 * Skeleton placeholder matching AlertTrendsChart layout
 * Shows chart title and simulated chart area with shimmer
 */
export function SkeletonChart({
  height = '300px',
  showTitle = true,
}: SkeletonChartProps) {
  return (
    <Card>
      <BlockStack gap="400">
        {showTitle && (
          <Box paddingBlockEnd="200">
            <div style={{ width: '200px' }}>
              <SkeletonBodyText lines={1} />
            </div>
          </Box>
        )}
        <div
          className="skeleton-shimmer"
          style={{
            height,
            backgroundColor: 'var(--p-color-bg-surface-secondary)',
            borderRadius: 'var(--p-border-radius-200)',
            display: 'flex',
            alignItems: 'flex-end',
            padding: 'var(--p-space-400)',
            gap: 'var(--p-space-200)',
          }}
        >
          {/* Simulated bar chart bars */}
          {Array.from({ length: 7 }).map((_, index) => {
            // Varying heights to simulate chart data
            const heights = [60, 80, 45, 90, 70, 55, 75];
            return (
              <div
                key={index}
                style={{
                  flex: 1,
                  height: `${heights[index]}%`,
                  backgroundColor: 'var(--p-color-bg-fill-tertiary)',
                  borderRadius: 'var(--p-border-radius-100)',
                }}
              />
            );
          })}
        </div>
      </BlockStack>
    </Card>
  );
}

export type { SkeletonChartProps };
